import { RouterStore } from 'stores/RouterStore';
import ServiceStore from 'stores/ServiceStore';
import { RouteType } from 'types/RouteType';

const dispatchRoute: RouteType = {
  name: 'Dispatch',
  path: '/job/:jobNumber/dispatch',
  layout: '/app',
  viewportCard: {
    header: {
      title: 'Dispatch',
      // component: () => import('./Dispatch.Header'), // Assuming a Header component exists
      enableToolbox: true,
      enableBackButton: true,
      enableRefreshButton: true,
    },
    body: {
      // component: () => import('./Dispatch.Body'), // Assuming a Body component exists
      gridContainer: {
        namespace: 'DispatchDataGrid',
        storeName: 'dispatchStore',
        columnHeaders: [
          {
            width: 100, // Default width
            title: 'Hoist Day',
            key: 'hoistDay',
            dataType: 'number',
          },
          {
            width: 100,
            title: 'Date',
            key: 'loadDate',
            dataType: 'date',
          },
          {
            width: 100,
            title: 'Time',
            key: 'loadTime',
          },
          {
            width: 100,
            title: 'No. of Drivers',
            key: 'numberOfDrivers',
            dataType: 'number',
          },
          {
            width: 100,
            title: 'Load #',
            key: 'loadNumber',
          },
          {
            width: 100,
            title: 'Trailer #',
            key: 'trailerNumber',
          },
          {
            width: 100,
            title: 'Trailer Type',
            key: 'trailerType',
          },
          {
            width: 100,
            title: 'Checked By',
            key: 'checkedBy',
          },
          {
            width: 100,
            title: 'Yard Location',
            key: 'yardLocation',
          },
          {
            width: 100,
            title: 'Largest Height',
            key: 'largestPanelHeight',
          },
          {
            width: 100,
            title: 'Largest Width',
            key: 'largestPanelWidth',
          },
          {
            width: 160,
            title: 'Height/Width Permit',
            key: 'permitRequiredLength',
          },
          {
            width: 100,
            title: 'Weight Permit',
            key: 'permitRequiredWeight',
          },
          {
            width: 100,
            title: 'Load Weight',
            key: 'loadWeight',
            dataType: 'number',
          },
          {
            width: 100,
            title: 'No. Of Panels',
            key: 'numberOfPanels',
            dataType: 'number',
          },
          {
            width: 100,
            title: 'Invoice',
            key: 'invoice',
          },
          {
            width: 100,
            title: 'Notes',
            key: 'notes',
          },
        ],
        // defaultSort: {
        //   sortBy: ['name'],
        //   sortDirection: { name: 'ASC' },
        // },
        onRowClick: () => console.log('Clicked'),
        // onRowClick: ({ controlUUID }) =>
        // openDialog({
        //   dialogName: 'QR Code',
        //   dialogContext: controlUUID
        // })
      },
    },
  },
  group: 'Dispatch',
  requiresAuth: true, // Assuming auth is required, adjust as needed
  requiresPermission: false,
  permissionPath: '/app/dispatch', // Based on permissionPath
  channels: [
    // 'job/:jobNumber',
    // 'job-plant/:jobNumber',
    // 'load/:jobNumber',
    // 'trailer',
    // 'panel-revit/:jobNumber',
    // 'panel-plant/:jobNumber',
    // 'panel-yard/:jobNumber',
    // 'comments',
  ],
  enableAutoFind: false,
  hidden: true,
  projectRoute: true,
  onEnter: async ({ rootStore }) => {
    const loadStore = rootStore.loadStore as ServiceStore;
    const trailerStore = rootStore.trailerStore as ServiceStore;

    const { params } = rootStore.routerStore as RouterStore;

    loadStore?.find({ query: { jobNumber: params.jobNumber } });
    trailerStore?.find();
  },
};

export default dispatchRoute;
